const SMALL_BAG = 3.5;
const LARGE_BAG = 10;

const SNACKS = 0.5;
const SMALL_MEAL = 0.83;
const REGULAR_MEAL = 1;

export default class OrderHelper {

  static getNumberOfBags(orders, days, size = 'medium', stream) {
    if (orders.logistics && orders.logistics[days[0]] && orders.logistics[days[0]].bags) {
      return orders.logistics[days[0]].bags;
    }
    let total = this.getSizeValue(orders, days, size, stream);
    let bags = 0;
    if (total >= 8) {
      total = total / LARGE_BAG;
      bags = Math.ceil(total);
    } else {
      total = total / SMALL_BAG;
      bags = Math.ceil(total);
    }
    return bags;
  }

  static getSizeOfBags(orders, days, size = 'medium', stream) {
    if (orders.logistics && orders.logistics[days[0]] && orders.logistics[days[0]].bagSize) {
      return orders.logistics[days[0]].bagSize;
    }
    let total = this.getSizeValue(orders, days, size, stream);
    if (total >= 8) {
      return 'large';
    }
    return 'small';
  }

  static getBins(orders, days) {
    const bins = {};
    {
      for (const day of days) {
        const ordersOnDay = orders.meals[day];
        if (ordersOnDay) {
          ordersOnDay.forEach(o => o.bin && (bins[o.bin] = 1));
        }
      }
    }
    function extractLetterAndNumber(s) {
      return s && (s[0] + s.split('-')[1]);
    }
    return Object.keys(bins).map(extractLetterAndNumber).sort();
  }

  static getSizeValue(orders, days, size, stream) {
    let total = 0.0;
    let mealValue = size === 'small' ? SMALL_MEAL : REGULAR_MEAL;
    for (const day of days) {
      const order = orders.meals[day];
      if (order) {
        for (let item of order) {
          if (item.tod !== 'extras') {
            total += item.quantity * mealValue;
          } else {
            total += item.quantity * SNACKS;
          }

          if (item.tod === 'breakfast' && item.order_type !== 'chefs_choice' && stream !== 'keto') {
            total += item.quantity * SNACKS;
          }
        }
      }
    }
    return total;
  }
}



// WEBPACK FOOTER //
// ./src/helpers/orderHelper.js